module.exports = __webpack_public_path__ + "static/media/sksnare.762a93cb.wav";